<template>
  <div class="el-top-nav-menu3" :style="style1">
    <div class="sub-menu-wrapper-wrapper">
      <div class="sub-menu-wrapper" :style="style">
        <div class="logo-container">
          <router-link :to="dashboard" v-if="dashboard">
            <img
              :src="logo"
              alt=""
              class="src"
              style="height: 40px; width: 40px; border: 0"
            />
            <span class="app-name">
              <p class="appTitle">{{ appTitle }}</p>
              <p :title="companyTitle" class="companyTitle">
                {{ companyTitle }}
              </p>
            </span>
          </router-link>
          <div class="cursorPointer" v-if="!dashboard">
            <img
              :src="logo"
              alt=""
              class="src"
              style="height: 40px; width: 40px; border: 0"
            />
            <span class="app-name">
              <p class="appTitle">{{ appTitle }}</p>
              <p :title="companyTitle" class="companyTitle">
                {{ companyTitle }}
              </p>
            </span>
          </div>
        </div>
        <!-- <div class="border-hr"></div> -->
        <ul class="nav">
          <li
            @click="skip(item, index)"
            v-for="(item, index) in subMenu1"
            :key="index"
          >
            <a
              ><span
                :class="routeFormat() == index ? 'nav-items' : 'nav-itemy'"
                >{{ item.name }}</span
              ></a
            >
          </li>
          <el-popover
            v-if="subMenu.length > 9"
            placement="bottom-end"
            width="100"
            popperClass="btn menu3Menu"
            v-model="visible"
          >
            <li
              @click="skip(item, index)"
              class="nav-item el-popper-btn"
              style="text-align: center; margin: 0"
              v-for="(item, index) in subMenu2"
              :key="index"
            >
              <router-link :redirect="item.m" :to="{ path: item.url }">
                <span>{{ item.name }}</span>
              </router-link>
            </li>
            <el-button
              icon="el-icon-arrow-down"
              slot="reference"
              style="color: #fff"
              type="text"
            ></el-button>
          </el-popover>
        </ul>
        <i class="icon-ccui-help" @click="ccuiHelp"></i>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import Axios from "axios";
import Cookies from "js-cookie";
import { signLogin } from "@/config/api/login";

export default {
  name: "ElTopNavMenu3",
  props: {
    headers: {
      type: Object,
      default: () => {
        return {
          APP_TOKEN: Cookies.get("appToken"),
          Authorization: Cookies.get("access_token"),
        };
      },
    },
    agentId: {
      type: String,
      default:
        "9F6FD19CCFA4A74EEA3E4B95AF093CFDAA9882717EDF24A0D319F21AE8AE5C6F",
    },
    appTitle: String,
    companyTitle: String,
    appId: {
      type: String,
      default: "100030",
    },
    minWidth: {
      type: String,
      default: "1180px",
    },
    Width: {
      type: String,
      default: "1080px",
    },
    width: {
      type: String,
      default: "auto",
    },
    maxWidth: String,
    logo: {
      type: String,
      default:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAEoklEQVRYR72YeYjVVRTHP99220xbKCraI7KFTAgK0ZdNJUhEJFFJ2Dpt9EcLbQQzJGS0GBFFJlEklVNUtGCUwqQ1tCBW0F6klUQxpRmUrSe+w33wGN979/7eczp/vnd+537vWb/niv9BImJH4CRgF+BVSb+VHqtSxU70ImI34GLgLOB+4FlJ/1SxNSYAI2J74ALgVuArYK6kb6sAq+tucYARcTywIIV0AOiVtLETcP5miwCMiInAPsAZwC2Ac26Jwyvp907BdQwwIrYGpgDnAqcC+wMO67ZAAF8C2wFDwFPA8iqF0XihSh6MCOufBtwOTAa2auKd94AXk47/NuA1KeyLqnq0GGBE7AXcm7zWDJjBDAM9wA3AeaPAG+i7wBWSVpeGvQhgRBwKvABMamP4b+Aq4AngLeC4Fro/psKxvaxkAUbEgcAy4JCMtcEUfjdj56B7YCvZAMyR9EoOYVuAEbGDOz8wLWPIk6FH0lBEHAx8DriQ2slHwMxcf8wBnJeabe6iLoozJUVEHA2836KARttZDFwi6Y9WB7QEmPLOB+2UQWfjp0h6c6RkqwF0j5zdLtTtAD7oisu5DlgJzJD0VwJ4JPBhQYjrpp2HZ0va1OyspgAjYnyaobtnALp1XCvpvrpeROwBfA3sXHA5q6x3cUly/9xMWgF0M3Zx5MReO1bSJw0APebeAY7KfZz+9yWvk+T5XQzwLuD6ggMcysmNFCqNwUcTmykwMaIy0Ltw1ZyFvVNG0qRRWnlwOXByQXgflrRZnkbEbODpwkr2MR/0D26Y3leb4P5YBNAczv2snfwLXCTp8UaliHDVm6TenchDiRfX3Dy4qTa/Ns4zuwjgd8C+GcsOx1RJzje3F8/nc4B+4LASVA06625bsbE2b9r4L0oBlnjwV3tZ0nCqehOJuRXC2oilsgdfd/PNeMEU/gBg18T5Zlb0WqP66puWra/d2TPxl1IPzgduzBz4dqL1i4ALuwDnTwf6Bzm/ryYzoqIcnAG8lgnXy8BDwEsdhrUOxH3wGkkPNLtkqzbj309PXpzaAsDzgCdOrh3lnPuz1wZJq4oBpqocB3g+npDahhcis+q6fAqYyG6TQ9Dif3cBj7dHgCcl/VkVoBch0/YF/jhtbncAlyVDDk2W8DYcan2vn5+l9HnOpCK3yOf4YB9wInCppLUR4dw0u7Z4Vt8DHAOYde89ipoZkHeUdQnUxyYRkn6q4vEcQK+OLgavmN7kvEc4Vya4OCQ57GMq2RBFhCfKG2n0OTz2lPeNIUl+EKokaeIcBHxT55DtDGQBpoJxCJ9Jnqzb+yHl40pJ5nQtJYHyKuCK96VMMjwMslIEMIF0WE0A/ChUr1znmbu/R6NzbG0qBH9i2/ulSve6as97bl8uybpFUgywbi0ipqcGfUTRCWDW4y3Pl1vcbkFqZq8ywOTNWel5YymwJ3A44BXVjMZedU/7HliRHpGcBk13jtwlOwVoWu+Hoce8j0SEm7qLyaG3x4YleUJ0LR0BTF682kUjyRRrzKQbgKZZfgOclZsG3aDvGGDy4pXAUkleM8dEugXo3XdSnfaPBcKuAI4FoNE2/wMMMIY4QGNTMwAAAABJRU5ErkJggg==",
    },
    dashboard: String,
    subMenu: Array,
    defaultIndex: String,
  },
  data() {
    return {
      visible: false,
      iccecUrl: "/apis/basap/login/iccec",
      subMenu1: [],
      subMenu2: [],
    };
  },
  mounted() {
    this.subMenu1 = this.subMenu;
    if (this.subMenu.length > 9) {
      this.subMenu2 = this.subMenu.slice(9);
      this.subMenu1 = this.subMenu.slice(0, 9);
    } else {
      this.subMenu1 = this.subMenu;
    }
  },
  methods: {

  routeFormat(path) {
      if(this.$route.path.indexOf('expertManage/expertManages') > -1) {
        return 1;
      }else {
      return 0;
      }
    },
    addUrlPerFix(url) {
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "ccui.iccec.cn"
      ) {
        let arr = window.location.hostname.split("-");
        let perfix = arr.length === 1 ? "" : arr[0] + "-";
        return (
          window.location.protocol +
          "//" +
          perfix +
          process.env.VUE_APP_BASE_URL +
          url
        );
        // return window.location.protocol + "//test01-"+ process.env.VUE_APP_BASE_URL + url;
      } else {
        let arr = window.location.hostname.split("-");
        let perfix = arr.length === 1 ? "" : arr[0] + "-";
        return (
          window.location.protocol +
          "//" +
          perfix +
          process.env.VUE_APP_BASE_URL +
          url
        );
      }
    },
    iccec(item) {
      // appId: 100030
      // oma_remote_url: "http://test1.iccec.cn:8080/html/portal/engineerBid.html"
      let params = Object.assign({}, this.paramSearch);
      params.appId = this.appId;
      params.oma_remote_url = item;
      signLogin(params).then((res) => {
        let dataRows = res.data;
        console.log(dataRows.code);
        if (dataRows.code === "0") {
          window.open(dataRows.data, "_blank");
        }
      });
      // Axios({
      //   method: "post",
      //   url: this.addUrlPerFix(this.iccecUrl),
      //   data: params
      // }).then(res => {
      //   let dataRows = res.data;
      //   console.log(dataRows.code);
      //   if (dataRows.code === '0') {
      //     window.open(dataRows.data,'_blank')
      //   }
      // });
    },
    skip(item, index) {
      if (item.keyword) {
        if (item.keyword === "OUTLINK-ICCEC1") {
          this.iccec(item.url);
        }
      }
      this.$emit("onSubmitSkip", item);
    },
    toLink(item) {
      // keyword: "OUTLINK-ICCEC1"
      if (item.keyword) {
        if (item.keyword === "OUTLINK-ICCEC1") {
          return "toLink";
        }
      } else {
        return "click";
      }
    },
    ccuiHelp(item) {
      this.$emit("ccuiHelp", item);
    },
  },
  watch: {
    subMenu() {
      this.subMenu1 = this.subMenu;
      if (this.subMenu.length > 9) {
        this.subMenu2 = this.subMenu.slice(9);
        this.subMenu1 = this.subMenu.slice(0, 9);
      } else {
        this.subMenu1 = this.subMenu;
      }
    },
  },
  computed: {
    style() {
      let style = {};
      style.margin = "0 auto";
      style.maxWidth = "1700px";
      return style;
    },
    style3() {
      let style = {};
      style.margin = "0 auto";
      style.maxWidth = "1730px";
      return style;
    },
    style2() {
      let style = {};
      style.height = "80px";
      style.margin = "0 auto";
      style.maxWidth = "1740px";
      style.paddinTop = "15px";
      return style;
    },
    style1() {
      let style1 = {};
      style1.minWidth = this.minWidth;
      style1.width = this.width;
      style1.margin = " 0 auto";
      return style1;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-itemy {
  border: none;
   height: 42px;
    box-sizing: border-box;
  border-bottom: 2px solid #ffffff;
}
.nav-items {
    color: #0089ef;
    border: none;
    height: 42px;
    box-sizing: border-box;
    border-bottom: 2px solid #0089ef;
}
.border-hr {
  border-right: 1px solid #fff;
  opacity: 0.8;
  width: 1px;
  height: 30px;
  position: absolute;
  left: 130px;
  top: 33%;
}
.app-name {
  padding-right: 15px;
}
.logo-container {
  width: 128px !important;
  .app-name {
    width: 68px !important;
  }
}
.el-top-nav-menu3 .nav {
  margin-left: 132px;
}
.el-top-nav-menu3 .nav li .router-link-active {
  background: none !important;
  border-bottom: none !important;
}
.el-top-nav-menu3 .nav li a:hover {
  background: border-box;
  cursor: default;
  border: none;
}
.cursorPointer {
  width: 140px !important;
  .app-name {
    width: 80px !important;
    .appTitle {
      width: 80px !important;
    }
    .companyTitle {
      width: 80px !important;
    }
  }
}
</style>
